module.exports = __webpack_public_path__ + "img/hero.8452ef6a.png";